export default {
  install(app) {
    const translations = {
      zh: {
        home: {
          label: '开发者工具',
          title: '工具',
          titleAccent: '集合',
          subtitle: '简洁高效的在线工具，让日常工作更轻松',
          footer: {
            icp: '粤ICP备2025373736号-2',
            contact: 'zane4j@gmail.com'
          }
        },
        tools: {
          qrcode: { name: '二维码生成', desc: '输入链接，生成二维码' },
          json: { name: 'JSON 转换', desc: '格式化与压缩 JSON' },
          password: { name: '密码生成', desc: '自定义长度与字符' },
          timestamp: { name: '时间戳转换', desc: 'Unix 与日期互转' },
          base64: { name: 'Base64 编解码', desc: '文本与 Base64 互转' },
          url: { name: 'URL 编解码', desc: 'URL 特殊字符处理' },
          hash: { name: '哈希生成', desc: 'MD5/SHA 哈希计算' },
          uuid: { name: 'UUID 生成', desc: '批量生成唯一标识符' },
          cron: { name: 'Cron 表达式', desc: '生成与解析定时任务' },
          dictation: { name: '单词听写', desc: '朗读单词并生成听写顺序' }
        },
        pages: {
          qrcode: { title: '二维码生成', subtitle: '输入链接，生成可扫描的二维码图片', inputPlaceholder: 'https://example.com', button: '生成', download: '下载 PNG', placeholder: '输入链接后点击生成按钮' },
          json: { title: 'JSON 转换', subtitle: '格式化、压缩与验证 JSON 数据', inputLabel: '输入 JSON', outputLabel: '输出结果', format: '格式化', minify: '压缩', clear: '清空', copy: '复制', download: '下载', placeholder: '转换后的结果将显示在这里' },
          password: { title: '密码生成', subtitle: '自定义长度与字符类型，生成安全密码', length: '密码长度', uppercase: '大写字母', lowercase: '小写字母', numbers: '数字', special: '特殊字符', generate: '重新生成', copy: '复制' },
          timestamp: { title: '时间戳转换', subtitle: 'Unix 时间戳与日期时间互相转换', tsToDate: '时间戳 → 日期', dateToTs: '日期 → 时间戳', currentTime: '当前时间', timestampLabel: '时间戳（秒）', dateLabel: '日期时间', convert: '转换', placeholder: '输入 Unix 时间戳（秒或毫秒）' },
          base64: { title: 'Base64 编解码', subtitle: '文本与 Base64 字符串互相转换', textToB64: '文本编码为 Base64', b64ToText: 'Base64 解码为文本', inputPlaceholder: { text: '输入要编码的文本...', b64: '输入要解码的 Base64 字符串...' }, encode: '编码', decode: '解码', outputPlaceholder: { b64: 'Base64 输出', text: '文本输出' } },
          url: { title: 'URL 编解码', subtitle: 'URL 特殊字符的编码与解码处理', textToUrl: '文本编码为 URL', urlToText: 'URL 解码为文本', inputPlaceholder: { text: '输入要编码的 URL 或文本...', url: '输入要解码的 URL 编码字符串...' }, encode: '编码', decode: '解码', outputPlaceholder: { url: 'URL 编码输出', text: '文本输出' } },
          hash: { title: '哈希生成', subtitle: '计算文本的 MD5、SHA-1、SHA-256 等哈希值', inputLabel: '输入文本', generate: '生成哈希', placeholder: '输入要哈希的文本...' },
          uuid: { title: 'UUID 生成', subtitle: '批量生成 UUID v4 / v1 唯一标识符', regenerate: '重新生成', copy: '复制', batch: '批量生成', batchPlaceholder: '生成数量' },
          cron: { title: 'Cron 表达式', subtitle: '生成与解析 Cron 定时任务表达式', presets: '常用表达式', custom: '自定义表达式', nextRuns: '接下来 10 次执行时间', copy: '复制表达式' }
        }
      },
      en: {
        home: {
          label: 'DEV TOOLS',
          title: 'TOOL',
          titleAccent: 'BOX',
          subtitle: 'Clean & efficient online tools for your daily workflow',
          footer: {
            icp: '粤ICP备2025373736号-2',
            contact: 'zane4j@gmail.com'
          }
        },
        tools: {
          qrcode: { name: 'QR Generator', desc: 'Generate QR codes from links' },
          json: { name: 'JSON Converter', desc: 'Format & minify JSON' },
          password: { name: 'Password Generator', desc: 'Custom length & characters' },
          timestamp: { name: 'Timestamp Converter', desc: 'Unix ↔ Date conversion' },
          base64: { name: 'Base64 Encode/Decode', desc: 'Text ↔ Base64 conversion' },
          url: { name: 'URL Encode/Decode', desc: 'URL special character handling' },
          hash: { name: 'Hash Generator', desc: 'MD5/SHA hash calculation' },
          uuid: { name: 'UUID Generator', desc: 'Batch generate unique identifiers' },
          cron: { name: 'Cron Generator', desc: 'Generate & parse scheduled tasks' },
          dictation: { name: 'Word Dictation', desc: 'Play words aloud for dictation practice' }
        },
        pages: {
          qrcode: { title: 'QR Generator', subtitle: 'Generate scannable QR codes from links', inputPlaceholder: 'https://example.com', button: 'Generate', download: 'Download PNG', placeholder: 'Enter a link and click generate' },
          json: { title: 'JSON Converter', subtitle: 'Format, minify & validate JSON data', inputLabel: 'Input JSON', outputLabel: 'Output', format: 'Format', minify: 'Minify', clear: 'Clear', copy: 'Copy', download: 'Download', placeholder: 'Converted result will appear here' },
          password: { title: 'Password Generator', subtitle: 'Generate secure passwords with custom length & characters', length: 'Password Length', uppercase: 'Uppercase', lowercase: 'Lowercase', numbers: 'Numbers', special: 'Special Characters', generate: 'Regenerate', copy: 'Copy' },
          timestamp: { title: 'Timestamp Converter', subtitle: 'Convert between Unix timestamps & date time', tsToDate: 'Timestamp → Date', dateToTs: 'Date → Timestamp', currentTime: 'Current Time', timestampLabel: 'Timestamp (sec)', dateLabel: 'Date Time', convert: 'Convert', placeholder: 'Enter Unix timestamp (sec or ms)' },
          base64: { title: 'Base64 Encode/Decode', subtitle: 'Convert between text & Base64 strings', textToB64: 'Text → Base64', b64ToText: 'Base64 → Text', inputPlaceholder: { text: 'Enter text to encode...', b64: 'Enter Base64 string to decode...' }, encode: 'Encode', decode: 'Decode', outputPlaceholder: { b64: 'Base64 Output', text: 'Text Output' } },
          url: { title: 'URL Encode/Decode', subtitle: 'Encode & decode URL special characters', textToUrl: 'Text → URL', urlToText: 'URL → Text', inputPlaceholder: { text: 'Enter URL or text to encode...', url: 'Enter URL encoded string to decode...' }, encode: 'Encode', decode: 'Decode', outputPlaceholder: { url: 'URL Encoded Output', text: 'Text Output' } },
          hash: { title: 'Hash Generator', subtitle: 'Calculate MD5, SHA-1, SHA-256 hashes', inputLabel: 'Input Text', generate: 'Generate Hash', placeholder: 'Enter text to hash...' },
          uuid: { title: 'UUID Generator', subtitle: 'Batch generate UUID v4 / v1 identifiers', regenerate: 'Regenerate', copy: 'Copy', batch: 'Batch Generate', batchPlaceholder: 'Count' },
          cron: { title: 'Cron Generator', subtitle: 'Generate & parse Cron expressions', presets: 'Presets', custom: 'Custom Expression', nextRuns: 'Next 10 Runs', copy: 'Copy Expression' }
        }
      }
    }

    const state = {
      locale: localStorage.getItem('locale') || 'zh'
    }

    app.config.globalProperties.$i18n = {
      t(key) {
        const keys = key.split('.')
        let result = translations[state.locale]
        for (const k of keys) {
          result = result?.[k]
        }
        return result || key
      },
      locale: state.locale,
      toggle() {
        state.locale = state.locale === 'zh' ? 'en' : 'zh'
        localStorage.setItem('locale', state.locale)
      }
    }

    app.provide('i18n', app.config.globalProperties.$i18n)
  }
}
